import { useReactToPrint } from 'react-to-print';

function useReactToPrintCustom(options) {
  const handlePrint = useReactToPrint(options);

  return handlePrint;
}

export default useReactToPrintCustom;
